<app-lms-modal-frame [title]="'Employment Confirmation'" [pageHeadWidth]="500">
  <div modal-body class="center-screen">
    <form [formGroup]="confirmedForm" class="mx-2 py-0" ngNativeValidate>
      <table id="employConfirm" class="table table-striped table-sm">
        <caption>
          Loan Details
        </caption>

        <tbody>
          <tr>
            <td>
              <p class=" text-center text-wrap">
                <b>I confirm that I have contacted the client's employer,
                  and that the client is employed at the given employer.</b>
              </p>
            </td>
          </tr>

          <tr>
            <td>
              <div class="center-screen py-2">
                <label for="empConfirmed">Is employment confirmed?</label><br>
                <div class="form-check form-switch d-inline-flex mx-3 my-2 py-2">
                  <input
                    id="empConfirmed"
                    class="form-check-input"
                    type="checkbox"
                    formControlName="empConfirmed"
                  >
                </div>
                <p><strong>{{confirmedForm!.value.empConfirmed ? 'Confirmed employment!' :
                    'Employment NOT confirmed!'}}</strong></p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>

  <div modal-actions class="flex-container center-screen py-0 my-0">
    <button class="btn btn-primary" type="button" (click)="close()">Cancel</button>
    <button class="btn btn-primary" mdbRipple type="button" (click)="save()">Submit</button>
  </div>
</app-lms-modal-frame>
